document.addEventListener('turbo:load', function () {
  setupDynamicSidebar();
  setupCloseSidebarListeners();
});

window.openDynamicSidebar = function (type, url, title) {
  console.log('Opening dynamic sidebar:', type, url, title);
  document.getElementById('dynamicSidebar').classList.add('active');

  document.getElementById('sidebarBody').innerHTML = 'Loading...';
  document.getElementById('main-content').classList.add('overlay-active'); // Assuming your main content has an ID of 'main-content'
  document.getElementById('openEventPageBtn').href = url; // Use the same URL for the event details
  const eventImageLinks = document.querySelectorAll('.dynamic-sidebar a .event-show-image');

  eventImageLinks.forEach(function (image) {
    // Get the parent <a> tag of the image
    const link = image.closest('a');
    if (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault(); // Prevent navigation
        event.stopPropagation(); // Stop the event from bubbling up
      });
    }
  });

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      document.getElementById('sidebarBody').innerHTML = html;
    })
    .catch((error) => console.error('Error loading details:', error));
};

window.closeDynamicSidebar = function () {
  const sidebar = document.getElementById('dynamicSidebar');
  if (sidebar) {
    sidebar.classList.remove('active');
  }
  document.getElementById('main-content').classList.remove('overlay-active'); // Assuming your main content has an ID of 'main-content'
};

function setupDynamicSidebar() {
  document.querySelectorAll('[data-dynamic-sidebar]').forEach((item) => {
    item.addEventListener('click', function (event) {
      // Stop the default link behavior
      event.preventDefault(); // Add this line

      // Prevent the event from propagating to higher elements
      event.stopPropagation();

      const type = this.getAttribute('data-type');
      const url = this.getAttribute('data-detail-url');
      const title = this.getAttribute('data-title');
      window.openDynamicSidebar(type, url, title);
    });
  });
}

function setupCloseSidebarListeners() {
  // Close sidebar when clicking outside of it
  document.addEventListener('click', function (event) {
    const sidebar = document.getElementById('dynamicSidebar');
    if (sidebar && !sidebar.contains(event.target)) {
      closeDynamicSidebar();
    }
  });

  // Close sidebar with the close button
  if (document.getElementById('sidebarCloseBtn')) {
    document.getElementById('sidebarCloseBtn').addEventListener('click', closeDynamicSidebar);
  }
}
